import { createHook } from '@atlassian/eoc-rss-helpers';

import { type actions } from '../actions';
import { store } from '../index';
import { selectors } from '../selectors';
import { type initialState } from '../state';

const useTimelineRotations = createHook<
	typeof initialState,
	typeof actions,
	ReturnType<typeof selectors.getRotations>
>(store, {
	selector: selectors.getRotations,
});

const useTimelineEpoch = createHook<
	typeof initialState,
	typeof actions,
	ReturnType<typeof selectors.getEpoch>
>(store, {
	selector: selectors.getEpoch,
});

const useTimelineLoading = createHook<
	typeof initialState,
	typeof actions,
	ReturnType<typeof selectors.getLoading>
>(store, {
	selector: selectors.getLoading,
});

const useSchedule = createHook<
	typeof initialState,
	typeof actions,
	ReturnType<typeof selectors.getSchedule>
>(store, {
	selector: selectors.getSchedule,
});

const useRotation = createHook<
	typeof initialState,
	typeof actions,
	ReturnType<typeof selectors.getRotation>
>(store, {
	selector: selectors.getRotation,
});

const useHasDeleted = createHook<
	typeof initialState,
	typeof actions,
	ReturnType<typeof selectors.getHasDeleted>
>(store, {
	selector: selectors.getHasDeleted,
});

export {
	useTimelineRotations,
	useTimelineEpoch,
	useTimelineLoading,
	useSchedule,
	useRotation,
	useHasDeleted,
};
